import requestWrapper from "../utils/requestWrapper";
import { IGenericResponse } from "@/services/interfaces";
import { IOrderParams } from "@/services/interfaces/requests";

export default async (params: IOrderParams): Promise<IGenericResponse> => {
  const request = {
    url: params.data.isFromCart ? `/api/cart/orders` : `/api/orders`,
    method: "POST",
    data: params.data,
  };

  return await requestWrapper(request);
};
